<template>
    <div>
        <table class="table is-fullwidth is-size-7 is-hoverable">
            <thead>
                <tr>
                    <th>Id</th>
                    <th>Created</th>
                    <th>Registered</th>
                    <th>Confirmed</th>
                    <th>Canceled</th>
                    <th>Type</th>
                    <th>Amount</th>
                    <th>Key</th>
                    <th>Prn</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="payment in payments" :key="payment.id" :class="{ 'has-text-danger': !isPaymentSuccessfull(payment) }">
                    <td>{{ payment.id }}</td>
                    <td>{{ payment.createdAtUtc | datetime }}</td>
                    <td>{{ payment.registeredAtUtc | datetime }}</td>
                    <td>{{ payment.confirmedAtUtc | datetime }}</td>
                    <td>{{ payment.canceledAtUtc | datetime }}</td>
                    <td>{{ payment.type }}</td>
                    <td>{{ payment.amount | currency }}</td>
                    <td>{{ payment.key }}</td>
                    <td>{{ (JSON.parse(payment.prn) || {}).Prn }}</td>
                    <td>
                        <button class="button is-small info" @click="() => openPaymentDetails(payment)">Details</button>
                    </td>
                </tr>
            </tbody>
        </table>
        <pagination :page-size="10" @change="loadPaymentsAsync();" ref="pagination" />
        <modal v-if="selectedPayment" :class="{ 'is-active': isModalDetailsActive }" :onClose="() => {}">
            <header slot="header" class="modal-card-head has-text-centered">
                <p class="modal-card-title">Details</p>
                <button class="delete" aria-label="close" @click="closePaymentDetails"></button>
            </header>
            <section slot="content" class="modal-card-body">
                <pre>{{ selectedPayment }}</pre>
            </section>
            <footer slot="footer" class="modal-card-foot buttons is-right">
                <button v-if="!isPaymentSuccessfull(selectedPayment)" :disabled="isPaymentProcessing" class="button" style="position: absolute; left: 20px;" @click="() => sendPaymentAsync(selectedPayment.id)">Resend</button>
                <button :disabled="isPaymentProcessing" class="button" @click="() => reloadPaymentAsync(selectedPayment.id)">Reload</button>
                <button :disabled="isPaymentProcessing" class="button is-success" @click="closePaymentDetails">Close</button>
            </footer>
        </modal>
    </div>
</template>

<script>
    import pagination from "../../../common/pagination.vue";
    import modal from "../../../common/modal.vue";
    import kraService from "../../../../services/kra.service";

    export default {
        name: "client-kra-payments",
        components: { pagination, modal },
        data: () => ({
            payments: [],
            selectedPayment: null,
            isModalDetailsActive: false,
            isPaymentProcessing: false
        }),
        computed: {
            clientId: function() {
                return Number(this.$route.params.clientId);
            }
        },
        async mounted() {
            await this.loadPaymentsAsync();
        },
        methods: {
            async loadPaymentsAsync() {
                const data = await kraService.getPaymentsAsync({
                    clientId: this.clientId,
                    pageNumber: this.$refs.pagination.pageNumber,
                    pageSize: this.$refs.pagination.pageSize
                });

                this.payments.splice(0);
                this.payments.push(...data.items);
                this.$refs.pagination.set(data.pageNumber, data.totalPages);
            },
            openPaymentDetails(payment) {
                this.isModalDetailsActive = true;
                this.selectedPayment = payment;
            },
            closePaymentDetails() {
                this.isModalDetailsActive = false;
                this.selectedPayment = null;
            },
            async reloadPaymentAsync(paymentId) {
                this.isPaymentProcessing = true;
                const payment = await kraService.getPaymentAsync(paymentId);
                payment && this.payments.forEach((item, index) => item.id === payment.id && this.payments.splice(index, 1, payment) && (this.selectedPayment = payment));
                this.isPaymentProcessing = false;
            },
            async sendPaymentAsync(paymentId) {
                this.isPaymentProcessing = true;
                const payment = await kraService.sendPaymentAsync(paymentId);
                payment && await this.reloadPaymentAsync(payment.id);
                alert("Payment has been sent and updated.");
                this.isPaymentProcessing = false;
            },
            isPaymentSuccessfull(payment) {
                const message = (value => {
                    try {
                        const obj = JSON.parse(value);
                        return (obj && typeof obj === "object") ? obj : null;
                    }
                    catch (e) {
                        return null;
                    }
                })(payment.confirmationMessage);

                return message && message.Result && message.Result.ResultCode === 0;
            }
        },
        filters: {
            currency: function(value) {
                return (+value).toFixed(2);
            }
        }
    };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/kra/payments.vue